import { Accordion, AccordionItem, Button, Select, SelectItem, Switch, Tooltip } from "@heroui/react";
import { useEffect, useState } from "react";
import { Helmet } from "react-helmet";
import { DateRangePicker } from "materialui-daterange-picker";
import DateRangModal from "../../components/PopupModals/DateRangModal";
import { useDispatch, useSelector } from "react-redux";
import { clearRange2Data, fetchGlobalLeadCount, fetchOemWiseLeadCount, fetchOemWithSourceCount, fetchSourceWiseLeadCount, lineChartCounts, fetchSubsourceWiseOemLeadCount } from "../../redux/slices/dashboard";
import { IoFilter } from "react-icons/io5";
import BarChart from "../../components/Dashboard/BarChart";
import BarChartSkeleton from "../../components/Dashboard/BarChartSkeleton";
import LineChart from "../../components/Dashboard/LineChart";

const Dashboard = () => {
	const dispatch = useDispatch();

	const [isDateRangeOpen, setIsDateRangeOpen] = useState(false);
	const [activeRangeKey, setActiveRangeKey] = useState(null);
	const [selectedSource, setSelectedSource] = useState(0);
	const [selectedLineSource, setSelectedLineSource] = useState(0);
	const istTime = new Date(new Date().getTime() + 19800000);
	const initialStartDate = new Date(Date.UTC(istTime.getUTCFullYear(), istTime.getUTCMonth(), istTime.getUTCDate(), 0, 0, 0, 0) - 19800000).toISOString();
	const initialEndDate = new Date(Date.UTC(istTime.getUTCFullYear(), istTime.getUTCMonth(), istTime.getUTCDate(), 23, 59, 59, 999) - 19800000).toISOString();

	const [selectedLineDate, setSelectedLineDate] = useState({
		startDate: initialStartDate, // Now it's Dec 2nd (today)
		endDate: initialEndDate
	});

	const endDate1 = new Date();
	endDate1.setHours(23, 59, 59, 999);

	const startDate1 = new Date(endDate1.getFullYear(), endDate1.getMonth(), 1);


	const [appliedLineDate, setAppliedLineDate] = useState({
		startDate: startDate1.toISOString(),
		endDate: endDate1.toISOString()
	});



	const [ranges, setRanges] = useState({
		range1: { startDate: startDate1, endDate: endDate1 },
		range2: { startDate: null, endDate: null },
	});

	const openDateRange = (key) => {
		setActiveRangeKey(key);
		setIsDateRangeOpen(true);
	};

	const closeDateRange = () => {
		setIsDateRangeOpen(false);
		setActiveRangeKey(null);
	};

	const handleRangeSelect = (range) => {
		let end = null;
		if (range.endDate) {
			const e = new Date(range.endDate);
			e.setHours(23, 59, 59, 999);
			end = e.toISOString();
		}

		const formattedRange = {
			startDate: range.startDate ? new Date(range.startDate).toISOString() : null,
			endDate: end
		};

		if (activeRangeKey === 1) {
			setRanges((prev) => ({ ...prev, range1: formattedRange }));
		} else if (activeRangeKey === 2) {
			setRanges((prev) => ({ ...prev, range2: formattedRange }));
		}
		closeDateRange();
	};

	const handleSourceSelect = (source) => {
		setSelectedSource(Number(source.target.value))
	};

	const sources = [
		{ key: 0, label: "All Sources" },
		{ key: 1, label: "Website" },
		{ key: 2, label: "Meta Ads" },
		{ key: 3, label: "Google Ads" },
		{ key: 4, label: "Calling" },
		{ key: 5, label: "Excel" },
		{ key: 6, label: "Retargetting" },
	];

	const [oemType, setOemType] = useState(1);
	const [useConversionDateRange, setUseConversionDateRange] = useState(0);
	const [lineConversionDateRange, setLineConversionDateRange] = useState(0);
	const [viewOemAsPercent, setViewOemAsPercent] = useState(false);
	const [viewSubsourceAsPercent, setViewSubsourceAsPercent] = useState(false);
	const [viewOemSourceAsPercent, setViewOemSourceAsPercent] = useState(false);

	const [subsourceOem, setSubsourceOem] = useState(1);
	const [subsourceUseConversionDateRange, setSubsourceUseConversionDateRange] = useState(0);
	const [isSubsourceDateRangeOpen, setIsSubsourceDateRangeOpen] = useState(false);
	const [subsourceDateRange, setSubsourceDateRange] = useState({
		startDate: startDate1.toISOString(),
		endDate: endDate1.toISOString()
	});

	const oemOptions = [
		{ key: 1, label: "TVS EV" },
		{ key: 2, label: "Ola Electric EV" },
		{ key: 3, label: "Ampere EV" },
		{ key: 4, label: "Revolt" },
		{ key: 5, label: "Simple Energy" }
	];

	const { totalLeads1, acceptedLeads1, unprocessedLeads1, rejectedLeads1, totalLeadsUnique1, totalLeadsUnique2,
		totalLeads2, acceptedLeads2, unprocessedLeads2, rejectedLeads2, isLoading,
		loadingStates, oemWisePending, oemWiseData, oemSourceData, oemSourcePending, sourceWiseData, sourceWisePending,
		lineChartData, lineChartPending, subsourceWiseData, subsourceWisePending

	} = useSelector((state) => state.dashboardCounts || {});

	const ExecuteLineChartCounts = (dateRange = selectedLineDate, conversionDateRange = lineConversionDateRange) => {
		if (dateRange && dateRange.endDate && dateRange.startDate && selectedLineSource != null && oemType) {
			setAppliedLineDate(dateRange);

			dispatch(lineChartCounts({
				startDate: dateRange.startDate,
				endDate: dateRange.endDate,
				selectedSource: selectedLineSource,
				oem_type: oemType,
				useConversionDateRange: conversionDateRange
			}))
		}
	}

	const [isDualRange, setIsDualRange] = useState(false);

	const ExecuteAPIs = () => {
		setIsSwitchDisabled(true)
		setIsDualRange(ranges.range2.startDate && ranges.range2.endDate)

		const payloadBase = {
			startDate1: ranges.range1.startDate,
			endDate1: ranges.range1.endDate,
			startDate2: ranges.range2.startDate,
			endDate2: ranges.range2.endDate,
			source: selectedSource,
		};

		const dispatchOemCounts = (count_type) => [
			dispatch(fetchOemWiseLeadCount({ ...payloadBase, oem_type: count_type, useConversionDateRange, selectedSource })),
			dispatch(fetchOemWithSourceCount({ ...payloadBase, oem_type: count_type })),
		];

		Promise.all([
			dispatch(fetchSourceWiseLeadCount({ ...payloadBase, selectedSource })),
			dispatch(fetchGlobalLeadCount(payloadBase)),
			...[1, 2, 3, 4, 5].flatMap(dispatchOemCounts)
		])
			.then((err) => console.warn(err))
			.then(() => setIsSwitchDisabled(false))
	}

	const [isSwitchDisabled, setIsSwitchDisabled] = useState(false);

	const toggleConverted = (e) => {
		const val = e === true ? 1 : 0;
		setUseConversionDateRange(val);

		const payloadBase = {
			startDate1: ranges.range1.startDate,
			endDate1: ranges.range1.endDate,
			startDate2: ranges.range2.startDate,
			endDate2: ranges.range2.endDate,
			source: selectedSource,
		};
		setIsSwitchDisabled(true)

		const dispatchAllCounts = (count_type) => [
			dispatch(fetchOemWiseLeadCount({ ...payloadBase, oem_type: count_type, useConversionDateRange: val }))
		]

		Promise.all([
			dispatch(fetchSourceWiseLeadCount({ ...payloadBase, selectedSource })),
			...[1, 2, 3, 4, 5].flatMap(dispatchAllCounts)
		])
			.then(() => setIsSwitchDisabled(false))
			.then((err) => console.warn(err));
	}

	useEffect(() => {
		ExecuteAPIs()
		ExecuteLineChartCounts()
	}, [dispatch]);

	useEffect(() => {
		if (subsourceDateRange.startDate && subsourceDateRange.endDate) {
			dispatch(fetchSubsourceWiseOemLeadCount({
				startDate1: subsourceDateRange.startDate,
				endDate1: subsourceDateRange.endDate,
				oem_type: subsourceOem,
				useConversionDateRange: subsourceUseConversionDateRange
			}));
		}
	}, [dispatch, subsourceOem, subsourceDateRange, subsourceUseConversionDateRange]);

	const groupedOems = {};

	if (oemWiseData) {
		Object.values(oemWiseData).forEach((entry) => {
			const key = entry.oem_type;
			if (!groupedOems[key]) {
				groupedOems[key] = { range_0_data: entry, range_1_data: {} };
			} else {
				groupedOems[key].range_1_data = entry;
			}
		});
	}

	const SkeletonRow = ({ columns }) => (
		<tr className="animate-pulse">
			{Array.from({ length: columns }).map((_, i) => (
				<td key={i} className="px-3 py-3 w-36">
					<div className="h-4 bg-gray-200 rounded w-full"></div>
				</td>
			))}
		</tr>
	);

	const ResetFilters = () => {
		// Clear R2 data immediately
		dispatch(clearRange2Data());

		const endDate = new Date();
		endDate.setHours(23, 59, 59, 999);
		const startDate = new Date(endDate.getFullYear(), endDate.getMonth(), 1);

		setRanges({
			range1: { startDate: startDate.toISOString(), endDate: endDate.toISOString() },
			range2: { startDate: null, endDate: null },
		});

		setSelectedSource(0);
		setIsDualRange(false);
		setUseConversionDateRange(0);

		const payloadBase = {
			startDate1: startDate.toISOString(),
			endDate1: endDate.toISOString(),
			startDate2: null,
			endDate2: null,
			source: 0,
		};

		setIsSwitchDisabled(true);

		const dispatchOemCounts = (count_type) => [
			dispatch(fetchOemWiseLeadCount({ ...payloadBase, oem_type: count_type, useConversionDateRange: 0 })),
			dispatch(fetchOemWithSourceCount({ ...payloadBase, oem_type: count_type })),
		];

		Promise.all([
			dispatch(fetchSourceWiseLeadCount({ ...payloadBase, selectedSource: 0 })),
			dispatch(fetchGlobalLeadCount(payloadBase)),
			...[1, 2, 3, 4, 5].flatMap(dispatchOemCounts)
		])
			.then(() => setIsSwitchDisabled(false))
			.catch((err) => console.warn(err));
	}

	return (
		<>
			<Helmet>
				<title>Dashboard | EV-INDIA</title>
			</Helmet>

			<div className="px-6 py-4 h-full overflow-y-auto">
				<LineChart
					loading={lineChartPending}
					lineChartData={lineChartData}
					selectedLineDate={selectedLineDate}
					setSelectedLineDate={setSelectedLineDate}
					ExecuteLineChartCounts={ExecuteLineChartCounts}
					setOemType={setOemType}
					appliedLineDate={appliedLineDate}
					oemType={oemType}
					selectedLineSource={selectedLineSource}
					setSelectedLineSource={setSelectedLineSource}
					sources={sources}
					useConversionDateRange={lineConversionDateRange}
					setUseConversionDateRange={setLineConversionDateRange}
				/>

				<Accordion className="bg-white my-8 p-0 rounded-xl border-1 border-[#e3e3e3]">
					<AccordionItem startContent={<IoFilter />} className="bg-white py-0 px-4 rounded-xl" key="1" aria-label="Accordion 1" title={`Comparison & Filter Controls${ranges.range1.startDate && ranges.range1.endDate
						? `   R1: ${new Date(ranges.range1.startDate).toLocaleDateString()} → ${new Date(ranges.range1.endDate).toLocaleDateString()}`
						: ""
						}${ranges.range2.startDate && ranges.range2.endDate
							? `\u00A0\u00A0\u00A0R2: ${new Date(ranges.range2.startDate).toLocaleDateString()} → ${new Date(ranges.range2.endDate).toLocaleDateString()}`
							: ""
						}`}
					>
						{/* Date Range Selection */}
						<div className="grid grid-cols-1 md:grid-cols-2 gap-6 mb-4">
							{/* Range 1 */}
							<div className="bg-indigo-50 p-4 rounded-lg border border-indigo-200">
								<label className="block text-sm font-medium text-indigo-700 mb-2">
									Range 1 (R1)
								</label>
								<Button
									className="bg-white hover:bg-gray-100"
									variant="outlined"
									onPress={() => openDateRange(1)}
									fullWidth
								>
									{ranges.range1.startDate
										? `${new Date(ranges.range1.startDate).toLocaleDateString()} → ${new Date(ranges.range1.endDate).toLocaleDateString()}`
										: "Select Date Range"}

								</Button>
							</div>

							{/* Range 2 */}
							<div className="bg-teal-50 p-4 rounded-lg border border-teal-200">
								<label className="block text-sm font-medium text-teal-700 mb-2">
									Range 2 (R2) - for comparison
								</label>
								<Button
									className="bg-white hover:bg-gray-100"
									variant="outlined"
									onPress={() => openDateRange(2)}
									fullWidth
								>
									{ranges.range2.startDate
										? `${new Date(ranges.range2.startDate).toLocaleDateString()} → ${new Date(ranges.range2.endDate).toLocaleDateString()}`
										: "Select Date Range"}

								</Button>
							</div>
						</div>

						{/* Date Range Modal */}
						<DateRangModal
							className="w-[800px]"
							title={`Select Date Range ${activeRangeKey === 1 ? "(R1)" : activeRangeKey === 2 ? "(R2)" : ""
								}`}
							isOpen={isDateRangeOpen}
							onClose={closeDateRange}
						>
							<div className="flex dateRangePanel flex-col gap-[10px] border border-gray-100 p-4 rounded-md">
								<DateRangePicker
									open={true}
									toggle={closeDateRange}
									onChange={handleRangeSelect}
									initialDateRange={
										activeRangeKey === 1
											? {
												startDate: ranges.range1.startDate ? new Date(ranges.range1.startDate) : null,
												endDate: ranges.range1.endDate ? new Date(ranges.range1.endDate) : null,
											}
											: {
												startDate: ranges.range2.startDate ? new Date(ranges.range2.startDate) : null,
												endDate: ranges.range2.endDate ? new Date(ranges.range2.endDate) : null,
											}
									}

								/>
							</div>
						</DateRangModal>

						{/* Source Filter */}
						<div className="mt-6 pt-4 border-t border-gray-100">
							<label
								htmlFor="sourceFilter"
								className="block text-sm font-medium text-gray-700 mb-2"
							>
								Filter Global Metrics &amp; Chart (Does NOT filter OEM only table)
							</label>

							<Select selectedKeys={[String(selectedSource)]} onChange={e => handleSourceSelect(e)} variant="bordered" size="sm" className="max-w-xs" label="Select a source">
								{sources.map((source) => (
									<SelectItem key={source.key}>{source.label}</SelectItem>
								))}
							</Select>

						</div>

						<Button
							onClick={() => ExecuteAPIs()}
							isLoading={isLoading}
							className="mt-6 px-6 py-2 align-bottom bg-[#0085DB] text-white font-semibold rounded-lg hover:bg-[#0175c3] transition duration-150 mr-4"
						>
							Apply
						</Button>

						<Button
							onClick={() => ResetFilters()}
							isDisabled={isLoading}
							className="mt-6 px-6 py-2 font-semibold rounded-lg transition duration-150"
						>
							Reset
						</Button>
					</AccordionItem>
				</Accordion>

				<div class="card bg-white p-6 rounded-xl overflow-x-auto mb-4">
					<div className="flex flex-col md:flex-row md:items-center md:justify-between gap-4 mb-2">
						<div>
							<h2 className="text-2xl font-bold text-gray-900">OEM Wise Leads</h2>
							<div className="inline-flex items-center gap-2 whitespace-nowrap mt-1">
								<span className="font-bold text-sm">Total:</span>
								<span className="text-sm mr-2">
									R1:
									<span className={`ml-1 font-bold ${totalLeads2 > 0 ? "text-indigo-700" : "text-black"}`}>
										{`${totalLeads1} (${totalLeadsUnique1})`}
									</span>
								</span>

								{totalLeads2 > 0 && (
									<span className="text-sm">
										R2:
										<span className="ml-1 text-teal-700 font-bold">
											{`${totalLeads2} (${totalLeadsUnique2})`}
										</span>
									</span>
								)}
							</div>
						</div>
						<div className="flex items-center gap-2">
							<span className="text-sm font-medium text-gray-700">View as %</span>
							<Switch
								isSelected={viewOemAsPercent}
								onValueChange={(val) => setViewOemAsPercent(val)}
								size="sm"
							/>
						</div>
					</div>


					<div className="w-full overflow-x-auto">
						<table className="table-fixed min-w-full divide-y divide-gray-200" style={{ "text-align-last": 'left' }}>
							<thead className="bg-gray-50">
								{/* --- Top Group Header Row --- */}
								<tr>
									<th
										rowSpan="1"
										className="px-3 py-3 text-left text-sm font-bold text-gray-500 uppercase tracking-wider align-bottom w-[120px] max-w-[120px] border-b border-gray-200"
									>
									</th>

									<th
										colSpan={isDualRange ? 2 : 1}
										className="py-1 text-center text-xs font-medium text-gray-500 uppercase tracking-wider border-b border-gray-200"
									>
										Total Sent
									</th>

									<th
										colSpan={isDualRange ? 2 : 1}
										className="py-1 text-center text-xs font-medium text-gray-500 uppercase tracking-wider border-b border-gray-200"
									>
										Accepted
									</th>

									{isDualRange &&
										<th
											colSpan={1}
											className="py-1 text-center text-xs font-medium text-gray-500 uppercase tracking-wider border-b border-gray-200"
										>
											R1-R2 Comparison
										</th>
									}

									<th
										colSpan={isDualRange ? 2 : 1}
										className="py-1 text-center text-xs font-medium text-gray-500 uppercase tracking-wider border-b border-gray-200"
									>
										Rejected
									</th>

									<th
										colSpan={isDualRange ? 2 : 1}
										className="py-1 text-center text-xs font-medium text-gray-500 uppercase tracking-wider border-b border-gray-200"
									>
										Unprocessed
									</th>

									<th
										colSpan={isDualRange ? 2 : 1}
										className="py-1 text-center text-xs font-medium text-gray-500 uppercase tracking-wider border-b border-gray-200"
									>
										<div className="flex flex-row items-center gap-2">
											<span>Converted</span>
											<Tooltip content="Shows converted leads in the selected date range" delay={0} closeDelay={0}>
												<div className="flex items-center">
													<Switch className="py-2" isSelected={useConversionDateRange === 1} onValueChange={(e) => toggleConverted(e)} isDisabled={isSwitchDisabled} size="sm" />
												</div>
											</Tooltip>
										</div>
									</th>
								</tr>

								{/* --- Second Row: Individual Subcolumns --- */}
								<tr>
									{/* Accepted */}

									<th
										rowSpan="1"
										className="px-3 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider align-bottom w-[120px] max-w-[120px]"
									>
										OEM
									</th>

									<th className="py-2 text-center text-xs font-semibold text-green-800 tracking-wider w-20">
										{viewOemAsPercent ? "R1 %" : "R1 Cnt"}
									</th>
									{isDualRange && (
										<th className="py-2 text-center text-xs font-semibold text-green-800 tracking-wider w-20">
											{viewOemAsPercent ? "R2 %" : "R2 Cnt"}
										</th>
									)}

									<th className="py-2 text-center text-xs font-semibold text-green-800 tracking-wider w-20">
										{viewOemAsPercent ? "R1 %" : "R1 Cnt"}
									</th>
									{isDualRange && (
										<th className="py-2 text-center text-xs font-semibold text-green-800 tracking-wider w-20">
											{viewOemAsPercent ? "R2 %" : "R2 Cnt"}
										</th>
									)}

									{isDualRange && <th className="py-2 text-center text-xs font-semibold text-green-800 tracking-wider w-20">
										% Total
									</th>}

									{/* Rejected */}
									<th className="py-2 text-center text-xs font-semibold text-red-700 tracking-wider w-20">
										{viewOemAsPercent ? "R1 %" : "R1 Cnt"}
									</th>
									{isDualRange && (
										<th className="py-2 text-center text-xs font-semibold text-red-700 tracking-wider w-20">
											{viewOemAsPercent ? "R2 %" : "R2 Cnt"}
										</th>
									)}

									{/* Unprocessed */}
									<th className="py-2 text-center text-xs font-medium text-black tracking-wider w-20">
										{viewOemAsPercent ? "R1 %" : "R1 Cnt"}
									</th>
									{isDualRange && (
										<th className="py-2 text-center text-xs font-medium text-black tracking-wider w-20">
											{viewOemAsPercent ? "R2 %" : "R2 Cnt"}
										</th>
									)}

									{/* Converted */}
									<th className="py-2 text-center text-xs font-medium tracking-wider w-20">
										{viewOemAsPercent ? "R1 %" : "R1 Cnt"}
									</th>
									{isDualRange && (
										<th className="py-2 text-center text-xs font-medium text-black tracking-wider w-20">
											{viewOemAsPercent ? "R2 %" : "R2 Cnt"}
										</th>
									)}
								</tr>
							</thead>


							<tbody className="bg-white divide-y divide-gray-100 text-sm text-gray-700">
								{[
									{ id: 1, name: "TVS EV", key: "tvs" },
									{ id: 2, name: "Ola Electric EV", key: "ola" },
									{ id: 3, name: "Ampere EV", key: "ampere" },
									{ id: 4, name: "Revolt", key: "revolt" },
									{ id: 5, name: "Simple Energy", key: "simple" }
								].map(({ id, name, key }) => {
									if (!oemWiseData || oemWisePending[key]) {
										return <SkeletonRow key={id} columns={isDualRange ? 12 : 7} />;
									}

									if (!oemWiseData || !oemWiseData[id]) return null;

									const oem = oemWiseData[id];

									const r1 = oem.range_0_data || oem;
									const r2 = oem.range_1_data || {};

									let accPct = null;
									if (isDualRange && r1.acceptedLeads > 0 && r2.acceptedLeads >= 0) {
										const diff = ((r2.acceptedLeads - r1.acceptedLeads) / r1.acceptedLeads) * 100;
										const sign = diff > 0 ? "+" : "";
										const color = diff < 0 ? "text-red-600" : "text-green-700";
										accPct = <span className={`${color}`}>{`${sign}${diff.toFixed(2)}%`}</span>;
									}

									// Calculate R1 percentages
									const r1TotalSentPct = r1.totalLeads && totalLeads1 ? ((r1.totalLeads / totalLeads1) * 100).toFixed(2) : "0.00";
									const r1TotalSentUniquePct = r1.totalLeadsUnique && totalLeadsUnique1 ? ((r1.totalLeadsUnique / totalLeadsUnique1) * 100).toFixed(2) : "0.00";

									const r1AcceptedPct = r1.acceptedLeads && r1.totalLeads ? ((r1.acceptedLeads / r1.totalLeads) * 100).toFixed(2) : "0.00";
									const r1AcceptedUniquePct = r1.uniqueAcceptedLeads && r1.totalLeadsUnique ? ((r1.uniqueAcceptedLeads / r1.totalLeadsUnique) * 100).toFixed(2) : "0.00";

									const r1RejectedPct = r1.rejectedLeads && r1.totalLeads ? ((r1.rejectedLeads / r1.totalLeads) * 100).toFixed(2) : "0.00";
									const r1RejectedUniquePct = r1.uniqueRejectedLeads && r1.totalLeadsUnique ? ((r1.uniqueRejectedLeads / r1.totalLeadsUnique) * 100).toFixed(2) : "0.00";

									const r1UnprocessedPct = r1.unprocessedLeads && r1.totalLeads ? ((r1.unprocessedLeads / r1.totalLeads) * 100).toFixed(2) : "0.00";

									const r1ConvertedPct = r1.convertedLeads && r1.acceptedLeads ? ((r1.convertedLeads / r1.acceptedLeads) * 100).toFixed(2) : "0.00";

									// Calculate R2 percentages
									const r2TotalSentPct = r2.totalLeads && totalLeads2 ? ((r2.totalLeads / totalLeads2) * 100).toFixed(2) : "0.00";
									const r2TotalSentUniquePct = r2.totalLeadsUnique && totalLeadsUnique2 ? ((r2.totalLeadsUnique / totalLeadsUnique2) * 100).toFixed(2) : "0.00";

									const r2AcceptedPct = r2.acceptedLeads && r2.totalLeads ? ((r2.acceptedLeads / r2.totalLeads) * 100).toFixed(2) : "0.00";
									const r2AcceptedUniquePct = r2.uniqueAcceptedLeads && r2.totalLeadsUnique ? ((r2.uniqueAcceptedLeads / r2.totalLeadsUnique) * 100).toFixed(2) : "0.00";

									const r2RejectedPct = r2.rejectedLeads && r2.totalLeads ? ((r2.rejectedLeads / r2.totalLeads) * 100).toFixed(2) : "0.00";
									const r2RejectedUniquePct = r2.uniqueRejectedLeads && r2.totalLeadsUnique ? ((r2.uniqueRejectedLeads / r2.totalLeadsUnique) * 100).toFixed(2) : "0.00";

									const r2UnprocessedPct = r2.unprocessedLeads && r2.totalLeads ? ((r2.unprocessedLeads / r2.totalLeads) * 100).toFixed(2) : "0.00";

									const r2ConvertedPct = r2.convertedLeads && r2.acceptedLeads ? ((r2.convertedLeads / r2.acceptedLeads) * 100).toFixed(2) : "0.00";

									return (
										<tr key={id}>
											<td className="w-36 min-w-36 px-3 py-3 text-gray-900 whitespace-nowrap">{name}</td>
											<td className="w-36 min-w-36 text-center text-green-700 font-semibold">
												{viewOemAsPercent
													? `${r1TotalSentPct}% (${r1TotalSentUniquePct}%)`
													: `${r1.totalLeads || 0} (${r1.totalLeadsUnique || 0})`}
											</td>
											{isDualRange && (
												<td className="w-36 min-w-36 text-center text-green-700 font-semibold">
													{viewOemAsPercent
														? `${r2TotalSentPct}% (${r2TotalSentUniquePct}%)`
														: `${r2.totalLeads || 0} (${r2.totalLeadsUnique || 0})`}
												</td>
											)}
											<td className="w-36 min-w-36 text-center text-green-700 font-semibold">
												{viewOemAsPercent
													? `${r1AcceptedPct}% (${r1AcceptedUniquePct}%)`
													: `${r1.acceptedLeads || 0} (${r1.uniqueAcceptedLeads || 0})`}
											</td>
											{isDualRange && (
												<td className="w-36 min-w-36 text-center text-green-700 font-semibold">
													{viewOemAsPercent
														? `${r2AcceptedPct}% (${r2AcceptedUniquePct}%)`
														: `${r2.acceptedLeads || 0} (${r2.uniqueAcceptedLeads || 0})`}
												</td>
											)}
											{isDualRange && <td className="w-36 min-w-36 text-center">{accPct || "—"}</td>}
											<td className="w-36 min-w-36 text-center font-semibold text-red-700">
												{viewOemAsPercent
													? `${r1RejectedPct}% (${r1RejectedUniquePct}%)`
													: `${r1.rejectedLeads || 0} (${r1.uniqueRejectedLeads || 0})`}
											</td>
											{isDualRange && (
												<td className="w-36 min-w-36 text-center font-semibold text-red-700">
													{viewOemAsPercent
														? `${r2RejectedPct}% (${r2RejectedUniquePct}%)`
														: `${r2.rejectedLeads || 0} (${r2.uniqueRejectedLeads || 0})`}
												</td>
											)}
											<td className="w-36 min-w-36 text-center font-semibold text-black">
												{viewOemAsPercent
													? `${r1UnprocessedPct}%`
													: r1.unprocessedLeads || 0}
											</td>
											{isDualRange && (
												<td className="w-36 min-w-36 text-center font-semibold text-black">
													{viewOemAsPercent
														? `${r2UnprocessedPct}%`
														: r2.unprocessedLeads || 0}
												</td>
											)}
											<td className="w-36 min-w-36 text-center font-semibold text-black">
												{viewOemAsPercent
													? `${r1ConvertedPct}%`
													: r1.convertedLeads || 0}
											</td>
											{isDualRange && (
												<td className="w-36 min-w-36 text-center font-semibold text-black">
													{viewOemAsPercent
														? `${r2ConvertedPct}%`
														: r2.convertedLeads || 0}
												</td>
											)}
										</tr>
									);
								})}
							</tbody>
						</table>
					</div>

				</div>

				<div className="card bg-white p-6 rounded-xl overflow-x-auto mb-4 border border-gray-100">
					<div className="flex flex-col md:flex-row md:items-center md:justify-between gap-4 mb-4">
						<div>
							<h2 className="text-2xl font-bold text-gray-900">Subsource Wise Leads</h2>
							<p className="text-sm text-gray-500 mt-1">Showing lead status breakdown by subsource for the selected OEM and date range.</p>
						</div>
						<div className="flex flex-wrap items-center gap-4">
							{/* OEM Dropdown */}
							<div className="w-48">
								<Select
									selectedKeys={[String(subsourceOem)]}
									onChange={(e) => setSubsourceOem(Number(e.target.value))}
									variant="bordered"
									size="sm"
									label="Select OEM"
								>
									{oemOptions.map((oem) => (
										<SelectItem key={oem.key} textValue={oem.label}>{oem.label}</SelectItem>
									))}
								</Select>
							</div>

							{/* Date Range Picker Button */}
							<Button
								className="bg-white hover:bg-gray-100 border border-gray-300"
								variant="outlined"
								size="sm"
								onPress={() => setIsSubsourceDateRangeOpen(true)}
							>
								{subsourceDateRange.startDate
									? `${new Date(subsourceDateRange.startDate).toLocaleDateString()} → ${new Date(subsourceDateRange.endDate).toLocaleDateString()}`
									: "Select Date Range"}
							</Button>

							{/* View as % Switch */}
							<div className="flex items-center gap-2">
								<span className="text-sm font-medium text-gray-700">View as %</span>
								<Switch
									isSelected={viewSubsourceAsPercent}
									onValueChange={(val) => setViewSubsourceAsPercent(val)}
									size="sm"
								/>
							</div>
						</div>
					</div>

					<div className="w-full overflow-x-auto max-h-[450px] overflow-y-auto">
						<table className="table-fixed min-w-full divide-y divide-gray-200" style={{ textAlignLast: 'left' }}>
							<thead className="bg-gray-50 sticky top-0 z-10">
								<tr>
									<th className="px-3 py-3 text-left text-xs font-bold text-gray-500 uppercase tracking-wider align-bottom w-[200px] max-w-[200px] border-b border-gray-200">
										Subsource
									</th>
									<th className="py-2 text-center text-xs font-bold text-gray-500 uppercase tracking-wider border-b border-gray-200 w-28">
										{viewSubsourceAsPercent ? "Total Sent (%)" : "Total Sent"}
									</th>
									<th className="py-2 text-center text-xs font-bold text-gray-500 uppercase tracking-wider border-b border-gray-200 w-28">
										{viewSubsourceAsPercent ? "Accepted (%)" : "Accepted"}
									</th>
									<th className="py-2 text-center text-xs font-bold text-gray-500 uppercase tracking-wider border-b border-gray-200 w-28">
										{viewSubsourceAsPercent ? "Rejected (%)" : "Rejected"}
									</th>
									<th className="py-2 text-center text-xs font-bold text-gray-500 uppercase tracking-wider border-b border-gray-200 w-28">
										{viewSubsourceAsPercent ? "Unprocessed (%)" : "Unprocessed"}
									</th>
									<th className="py-2 text-center text-xs font-bold text-gray-500 uppercase tracking-wider border-b border-gray-200 w-28">
										<div className="flex flex-row items-center justify-center gap-2">
											<span>{viewSubsourceAsPercent ? "Converted (%)" : "Converted"}</span>
											<Tooltip content="Shows converted leads in the selected date range" delay={0} closeDelay={0}>
												<div className="flex items-center">
													<Switch
														className="py-2"
														isSelected={subsourceUseConversionDateRange === 1}
														onValueChange={(val) => setSubsourceUseConversionDateRange(val ? 1 : 0)}
														size="sm"
													/>
												</div>
											</Tooltip>
										</div>
									</th>
									<th className="py-2 text-center text-xs font-bold text-gray-500 uppercase tracking-wider border-b border-gray-200 w-28">
										% of Total Converted
									</th>
								</tr>
							</thead>
							<tbody className="bg-white divide-y divide-gray-100 text-sm text-gray-700">
								{subsourceWisePending ? (
									<SkeletonRow columns={7} />
								) : !subsourceWiseData || subsourceWiseData.length === 0 ? (
									<tr>
										<td colSpan={7} className="text-center py-8 text-gray-500 font-medium">
											No data available for the selected range and OEM.
										</td>
									</tr>
								) : (
									(() => {
										const totalSubsourceConverted = (subsourceWiseData || []).reduce((sum, row) => sum + (row.converted || 0), 0);
										const totalSubsourceSent = (subsourceWiseData || []).reduce((sum, row) => sum + (row.total || 0), 0);
										const totalSubsourceSentUnique = (subsourceWiseData || []).reduce((sum, row) => sum + (row.unique || 0), 0);

										return [...(subsourceWiseData || [])]
											.sort((a, b) => b.total - a.total)
											.map((row, idx) => {
												// Converted % calculation: count based on converted amount and accepted amount
												// Formula: (converted / accepted) * 100
												let convPercentStr = " (0.00%)";
												if (row.accepted > 0) {
													const pct = (row.converted / row.accepted) * 100;
													convPercentStr = ` (${pct.toFixed(2)}%)`;
												}

												let totalConvPercentStr = "0.00%";
												if (totalSubsourceConverted > 0) {
													const pct = ((row.converted || 0) / totalSubsourceConverted) * 100;
													totalConvPercentStr = `${pct.toFixed(2)}%`;
												}

												// Percentage strings for current row status values
												const totalSentPct = totalSubsourceSent ? ((row.total || 0) / totalSubsourceSent * 100).toFixed(2) : "0.00";
												const totalSentUniquePct = totalSubsourceSentUnique ? ((row.unique || 0) / totalSubsourceSentUnique * 100).toFixed(2) : "0.00";

												const acceptedPct = row.total ? ((row.accepted || 0) / row.total * 100).toFixed(2) : "0.00";
												const acceptedUniquePct = row.unique ? ((row.uniqueAccepted || 0) / row.unique * 100).toFixed(2) : "0.00";

												const rejectedPct = row.total ? ((row.rejected || 0) / row.total * 100).toFixed(2) : "0.00";
												const rejectedUniquePct = row.unique ? ((row.uniqueRejected || 0) / row.unique * 100).toFixed(2) : "0.00";

												const unprocessedPct = row.total ? ((row.unprocessed || 0) / row.total * 100).toFixed(2) : "0.00";

												const convertedPct = row.accepted ? ((row.converted || 0) / row.accepted * 100).toFixed(2) : "0.00";

												return (
													<tr key={idx}>
														<td className="w-[200px] max-w-[200px] px-3 py-3 text-gray-900 truncate" title={row.subSource}>
															{row.subSource}
														</td>
														<td className="text-center font-semibold text-green-700">
															{viewSubsourceAsPercent
																? `${totalSentPct}% (${totalSentUniquePct}%)`
																: `${row.total || 0} (${row.unique || 0})`}
														</td>
														<td className="text-center font-semibold text-green-700">
															{viewSubsourceAsPercent
																? `${acceptedPct}% (${acceptedUniquePct}%)`
																: `${row.accepted || 0} (${row.uniqueAccepted || 0})`}
														</td>
														<td className="text-center font-semibold text-red-700">
															{viewSubsourceAsPercent
																? `${rejectedPct}% (${rejectedUniquePct}%)`
																: `${row.rejected || 0} (${row.uniqueRejected || 0})`}
														</td>
														<td className="text-center font-semibold text-black">
															{viewSubsourceAsPercent
																? `${unprocessedPct}%`
																: row.unprocessed || 0}
														</td>
														<td className="text-center font-semibold text-black">
															{viewSubsourceAsPercent
																? `${convertedPct}%`
																: `${row.converted || 0}${convPercentStr}`}
														</td>
														<td className="text-center font-semibold text-black">
															{totalConvPercentStr}
														</td>
													</tr>
												);
											});
									})()
								)}
							</tbody>
						</table>
					</div>
				</div>

				{/* Subsource Date Range Modal */}
				<DateRangModal
					className="w-[800px]"
					title="Select Subsource Table Date Range"
					isOpen={isSubsourceDateRangeOpen}
					onClose={() => setIsSubsourceDateRangeOpen(false)}
				>
					<div className="flex dateRangePanel flex-col gap-[10px] border border-gray-100 p-4 rounded-md">
						<DateRangePicker
							open={true}
							toggle={() => setIsSubsourceDateRangeOpen(false)}
							onChange={(range) => {
								let end = null;
								if (range.endDate) {
									const e = new Date(range.endDate);
									e.setHours(23, 59, 59, 999);
									end = e.toISOString();
								}
								setSubsourceDateRange({
									startDate: range.startDate ? new Date(range.startDate).toISOString() : null,
									endDate: end
								});
								setIsSubsourceDateRangeOpen(false);
							}}
							initialDateRange={{
								startDate: subsourceDateRange.startDate ? new Date(subsourceDateRange.startDate) : null,
								endDate: subsourceDateRange.endDate ? new Date(subsourceDateRange.endDate) : null,
							}}
						/>
					</div>
				</DateRangModal>

				<div className="mb-4 mt-8"></div>
				{sourceWiseData && sourceWisePending === false && <BarChart isDualRange={isDualRange} rawData={sourceWiseData} />}
				{sourceWiseData && sourceWisePending === true && <BarChartSkeleton />}

				{/* Global leads count */}
				<div class="grid grid-cols-2 lg:grid-cols-4 gap-6 my-8">

					{loadingStates.total === false &&
						<div class="bg-white p-4 rounded-xl shadow-sm border border-gray-100">
							<p class="text-sm font-medium text-gray-500 mb-1">Total</p>
							<div class="flex flex-col items-start">
								<div class="flex justify-between w-full text-xs font-semibold uppercase text-gray-500 mb-1">
									<span class={`${totalLeads2 > 0 ? 'text-indigo-600' : 'text-black'}`}>R1</span>
									{totalLeads2 > 0 &&
										<span span class="text-teal-600">R2</span>
									}
								</div>
								<div class="flex justify-between w-full text-xl font-extrabold text-gray-900">
									<span class={`${totalLeads2 > 0 ? 'text-indigo-700' : 'text-black'}`}>{totalLeads1}</span>
									{totalLeads2 > 0 &&
										<span class="text-teal-700">{totalLeads2}</span>
									}
								</div>
							</div>
						</div>
					}

					{loadingStates.total === true &&
						<div div className="bg-gray-200 p-4 rounded-xl shadow-sm animate-pulse">
						</div>
					}

					{loadingStates.accepted === false &&
						<div class="bg-white p-4 rounded-xl shadow-sm border border-gray-100">
							<p class="text-sm font-medium text-gray-500 mb-1">Accepted</p>
							<div class="flex flex-col items-start">
								<div class="flex justify-between w-full text-xs font-semibold uppercase text-gray-500 mb-1">
									<span class={`${acceptedLeads2 > 0 ? 'text-indigo-600' : 'text-black'}`}>R1</span>
									{acceptedLeads2 > 0 &&
										<span class="text-teal-600">R2</span>
									}
								</div>
								<div class="flex justify-between w-full text-xl font-extrabold text-gray-900">
									<span class={`${acceptedLeads2 > 0 ? 'text-indigo-700' : 'text-black'}`}>{acceptedLeads1}</span>
									{acceptedLeads2 > 0 &&
										<span class="text-teal-700">{acceptedLeads2}</span>
									}
								</div>
							</div>
						</div>
					}

					{loadingStates.accepted === true &&
						<div div className="bg-gray-200 p-4 rounded-xl shadow-sm animate-pulse">
						</div>
					}

					{loadingStates.rejected === false &&
						<div class="bg-white p-4 rounded-xl shadow-sm border border-gray-100">
							<p class="text-sm font-medium text-gray-500 mb-1">Rejected</p>
							<div class="flex flex-col items-start">
								<div class="flex justify-between w-full text-xs font-semibold uppercase text-gray-500 mb-1">
									<span class={`${rejectedLeads2 > 0 ? 'text-indigo-600' : 'text-black'}`}>R1</span>
									{rejectedLeads2 > 0 &&
										<span class="text-teal-600">R2</span>
									}
								</div>
								<div class="flex justify-between w-full text-xl font-extrabold text-gray-900">
									<span class={`${rejectedLeads2 > 0 ? 'text-indigo-700' : 'text-black'}`}>{rejectedLeads1}</span>
									{rejectedLeads2 > 0 &&
										<span class="text-teal-700">{rejectedLeads2}</span>
									}
								</div>
							</div>
						</div>
					}

					{loadingStates.rejected === true &&
						<div div className="bg-gray-200 p-4 rounded-xl shadow-sm animate-pulse">
						</div>
					}

					{loadingStates.unprocessed === false &&
						<div class="bg-white p-4 rounded-xl shadow-sm border border-gray-100">
							<p class="text-sm font-medium text-gray-500 mb-1">Unprocessed</p>
							<div class="flex flex-col items-start">
								<div class="flex justify-between w-full text-xs font-semibold uppercase text-gray-500 mb-1">
									<span class={`${unprocessedLeads2 > 0 ? 'text-indigo-600' : 'text-black'}`}>R1</span>
									{unprocessedLeads2 > 0 &&
										<span class="text-teal-600">R2</span>
									}
								</div>
								<div class="flex justify-between w-full text-xl font-extrabold text-gray-900">
									<span class={`${unprocessedLeads2 > 0 ? 'text-indigo-700' : 'text-black'}`}>{unprocessedLeads1}</span>
									{unprocessedLeads2 > 0 &&
										<span class="text-teal-700">{unprocessedLeads2}</span>
									}
								</div>
							</div>
						</div>
					}

					{loadingStates.unprocessed === true &&
						<div div className="bg-gray-200 p-4 rounded-xl shadow-sm animate-pulse">
						</div>
					}

				</div>

				<div className="flex flex-col md:flex-row md:items-center md:justify-between gap-4 mb-4 mt-8">
					<h2 className="text-2xl font-bold text-gray-900">OEM + Source Wise Leads (Accepted)</h2>
					<div className="flex items-center gap-2">
						<span className="text-sm font-medium text-gray-700">View as %</span>
						<Switch
							isSelected={viewOemSourceAsPercent}
							onValueChange={(val) => setViewOemSourceAsPercent(val)}
							size="sm"
						/>
					</div>
				</div>
				<div class="card bg-white p-4 rounded-xl overflow-x-auto">
					<table class="min-w-full divide-y divide-gray-200">
						<thead className="bg-gray-50">
							<tr>
								<th
									rowSpan="2"
									className="px-3 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider align-bottom w-20"
								>
									OEM
								</th>

								{[
									{ label: "Website" },
									{ label: "Meta Ads" },
									{ label: "Google Ads" },
									{ label: "Calling" },
									{ label: "Excel" },
									{ label: "OLA-FORCE" }
								].map(({ label }) => (
									<th
										key={label}
										colSpan={isDualRange ? 2 : 1}
										className="py-1 text-center text-xs font-medium text-gray-500 uppercase tracking-wider border-b border-gray-200"
									>
										{label}
									</th>
								))}
							</tr>

							<tr>
								{[
									{ color: "text-blue-600" },
									{ color: "text-pink-600" },
									{ color: "text-orange-600" },
									{ color: "text-green-600" },
									{ color: "text-purple-600" },
									{ color: "text-indigo-600" }
								].flatMap(({ }, idx) =>
									isDualRange
										? [
											<th
												key={`${idx}-r1`}
												className={`px-3 py-2 text-center text-xs font-medium tracking-wider`}
											>
												{viewOemSourceAsPercent ? "R1 %" : "R1 Cnt"}
											</th>,
											<th
												key={`${idx}-r2`}
												className={`px-3 py-2 text-center text-xs font-medium tracking-wider`}
											>
												{viewOemSourceAsPercent ? "R2 %" : "R2 Cnt"}
											</th>
										]
										: [
											<th
												key={`${idx}-r1-only`}
												className={`px-3 py-2 text-center text-xs font-medium tracking-wider`}
											>
												{viewOemSourceAsPercent ? "R1 %" : "R1 Cnt"}
											</th>
										]
								)}
							</tr>
						</thead>

						<tbody id="oemTableBodySource" class="bg-white divide-y divide-gray-200">
							{[
								{ id: 1, name: "TVS EV", key: "tvs" },
								{ id: 2, name: "Ola Electric EV", key: "ola" },
								{ id: 3, name: "Ampere EV", key: "ampere" },
								{ id: 4, name: "Revolt", key: "revolt" },
								{ id: 5, name: "Simple Energy", key: "simple" }
							].map(({ id, name, key }) => {
								if (oemSourcePending[key]) {
									return <SkeletonRow key={id} columns={isDualRange ? 13 : 7} />;
								}

								if (!oemSourceData || !oemSourceData[id]) return null;

								const oem = oemSourceData[id];
								const r1Data = oem.range_0_data?.[key] || [];
								const r2Data = oem.range_1_data?.[key] || [];

								const getCount = (data, sourceName) => {
									const source = data.find(item => item.name === sourceName);
									return source?.count || 0;
								};

								const getDisplayValue = (data, sourceName, totalCount) => {
									const count = getCount(data, sourceName);
									if (viewOemSourceAsPercent) {
										const pct = totalCount > 0 ? (count / totalCount) * 100 : 0;
										return `${pct.toFixed(2)}%`;
									}
									return count;
								};

								const r1Total = r1Data.reduce((sum, item) => sum + (item.count || 0), 0);
								const r2Total = r2Data.reduce((sum, item) => sum + (item.count || 0), 0);

								return (
									<tr key={id}>
										<td className="text-sm px-3 py-3 text-gray-900 whitespace-nowrap">{name}</td>

										<td className="text-sm text-center font-semibold">{getDisplayValue(r1Data, "websiteCount", r1Total)}</td>
										{isDualRange && <td className="text-sm text-center font-semibold">{getDisplayValue(r2Data, "websiteCount", r2Total)}</td>}

										<td className="text-sm text-center font-semibold">{getDisplayValue(r1Data, "metaCount", r1Total)}</td>
										{isDualRange && <td className="text-sm text-center font-semibold">{getDisplayValue(r2Data, "metaCount", r2Total)}</td>}

										<td className="text-sm text-center font-semibold">{getDisplayValue(r1Data, "googleCount", r1Total)}</td>
										{isDualRange && <td className="text-sm text-center font-semibold">{getDisplayValue(r2Data, "googleCount", r2Total)}</td>}

										<td className="text-sm text-center font-semibold">{getDisplayValue(r1Data, "callingCount", r1Total)}</td>
										{isDualRange && <td className="text-sm text-center font-semibold">{getDisplayValue(r2Data, "callingCount", r2Total)}</td>}

										<td className="text-sm text-center font-semibold">{getDisplayValue(r1Data, "excelCount", r1Total)}</td>
										{isDualRange && <td className="text-sm text-center font-semibold">{getDisplayValue(r2Data, "excelCount", r2Total)}</td>}

										<td className="text-sm text-center font-semibold">{getDisplayValue(r1Data, "olaForceExcelCount", r1Total)}</td>
										{isDualRange && <td className="text-sm text-center font-semibold">{getDisplayValue(r2Data, "olaForceExcelCount", r2Total)}</td>}
									</tr>
								);
							})}
						</tbody>
					</table>
				</div>

			</div >
		</>
	);
};

export default Dashboard;